import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";
import LandingPage from "./pages/LandingPage";
import BoardroomsPage from "./pages/BoardroomsPage";
import HotDeskingPage from "./pages/HotDeskingPage";
import LeasingPage from "./pages/LeasingPage";
import ModerateFeedbackPage from "./pages/ModerateFeedbackPage";
import KitPage from "./pages/KitPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/boardrooms" element={<BoardroomsPage />} />
          <Route path="/hot-desking" element={<HotDeskingPage />} />
          <Route path="/leasing" element={<LeasingPage />} />
          <Route path="/moderate/feedback/:id" element={<ModerateFeedbackPage />} />
          <Route path="/kit" element={<KitPage />} />
          <Route path="/toowoomba" element={<Navigate to="/boardrooms" replace />} />
          <Route path="/sunshine-coast" element={<Navigate to="/boardrooms" replace />} />
          <Route path="*" element={<LandingPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
